import React from "react";
import "./profilePic_CIF.jpg";
import { HashLink } from "react-router-hash-link";

import { ProjectList } from "../projects.data";
import ProjectStudy from "../components/ProjectStudy";

const Home = () => {
  const [projStudy, setProjStudy] = React.useState(null);

  const handleProjToggle = (projTitle) => {
    console.log("setting projStudy to ", projTitle);
    if (projStudy) {
      // prevents scroll on the background while project study is open
      document.body.style.overflow = "scroll";
      setProjStudy(null);
    } else {
      document.body.style.overflow = "hidden";
      setProjStudy(projTitle);
    }
  };

  const projects = ProjectList.map((proj) => {
    return (
      <div
        className="project"
        key={proj.title}
        onClick={() => handleProjToggle(proj.short_title)}
      >
        <img src={proj.coverImg} alt="project summary" />
        <div className="proj-caption">
          <div className="project-title"> {proj.short_title} </div>
          <div className="proj-desc">{proj.short_desc}</div>
        </div>
      </div>
    );
  });

  const projectStudy = (
    <div className="overlay">
      <div className="study-box">
        <ProjectStudy
          proj={ProjectList.find((proj) => proj["short_title"] === projStudy)}
          onClose={handleProjToggle}
        />
      </div>
    </div>
  );
  return (
    <div>
      <div className="navbar">
        <HashLink smooth to="/#contact">
          Contact
        </HashLink>
        <HashLink smooth to="/#projects">
          Projects
        </HashLink>
        <HashLink smooth to="/#about">
          More Details
        </HashLink>
      </div>

      <div className="content">
        <div className="title-box" id="title">
          <div className="name-links-box">
            <div className="title">Hello, I'm Lucy</div>

            <div className="intro-buttons" id="contact">
              <a
                href="https://github.com/lucyking140"
                target="_blank"
                rel="noreferrer"
              >
                <button className="button-28"> GitHub </button>
              </a>
              <a
                href="https://www.linkedin.com/in/lucyking140/"
                target="_blank"
                rel="noreferrer"
              >
                <button className="button-28"> Linkedin</button>
              </a>
              <a href="mailto:lk2936@columbia.edu">
                <button className="button-28"> Email Me</button>
              </a>
            </div>
          </div>

          <img src="./profilePic.jpg" alt="Lucy's profile" />
        </div>

        <p>
          I’m a Computer Science and Math major at Columbia University
          interested in a career in software engineering, data science, and
          machine learning. I'm especially interested in the intersections of
          computer science and economics, and I have a passion for applying my
          technical skills to public policy. I’ve created this page to compile
          my personal projects. Thank you for checking it out!
        </p>

        <h2 id="projects" style={{ padding: "5px 0px 15px" }}>
          Projects
        </h2>

        <div className="project-list">{projects}</div>

        {projStudy && projectStudy}

        {/* <div className = "project-list">
                <div onClick={() => handleProjToggle("International Trade API Query Builder")}> <Project title="International Trade API Query Builder" desc = {census_sent} > </Project> </div>
                <div onClick={() => handleProjToggle("UNICC Climate Change Chatbot")}> <Project title="UNICC Climate Change Chatbot" desc = {unicc_sent}> </Project> </div>
                <div onClick={() => handleProjToggle("Lantern Die")}> <Project title="Lantern Die" desc = {ll_sent} > </Project> </div>
                <div onClick={() => handleProjToggle("AuctionAlchemy")}> <Project title="AuctionAlchemy" desc = {aa_sent}> </Project> </div>
            </div>  */}

        <br />

        <h2> Primary Technical Skills </h2>

        <div style={{ padding: "20px 0px 20px" }}>
          <div className="skill-list">
            <div className="skill"> Web Development </div>
            <div className="skill"> Relational Database Management </div>
            <div className="skill"> Machine learning </div>
          </div>
          <br />
          <div className="skill-list">
            <div className="skill"> Python (Django, Flask) </div>
            <div className="skill"> Java </div>
            <div className="skill"> SQL (PostgreSQL, MySQL) </div>
            <div className="skill"> React </div>
            <div className="skill"> JavaScript </div>
            <div className="skill"> HTML/CSS </div>
          </div>
        </div>

        <br />

        <h2> More About Me </h2>
        <br />
        <div className="content" id="about" style={{ padding: "0px 10px" }}>
          <strong> Relevant Coursework: </strong>
          <ul>
            <li>Data Structures (Teaching Assistant) </li>
            <li> Artificial Intelligence </li>
            <li> Introduction to Databases </li>
            <li> Machine Learning for Genomics </li>
            <li> Advanced Programming (Systems Programming, C, Bash) </li>
          </ul>
          <br />

          <strong> Community Involvement: </strong>
          <ul>
            <li>
              Columbia Women in Computer Science (DivHacks Hackathon 2023
              Organizing Team)
            </li>
            <li> Columbia Data Science Society (Executive Board) </li>
            <li>
              Columbia EcoReps (volunteer) and Greenborough (sustainable
              community member)
            </li>
            <li>
              Columbia Economics Society (Economics Department Representative
              2022 - 2023)
            </li>
            <li>
              Washington State Representative Tarra Simmons (campaign intern)
            </li>
            <li>
              Washington State Representative Emily Randall (youth
              councilmember)
            </li>
            <li>
              Chicago Justice Project (volunteer data collector and analyst;
              2022 Transparency Trailblazer Award for committing {">"} 150
              hours)
            </li>
          </ul>
          <br />

          <strong> Interests and Hobbies: </strong>
          <ul>
            <li> Public policy and government </li>
            <li> Tech for social good </li>
            <li> Computational Biology and Biotech </li>
            <li> Women/LGBTQ voices in tech </li>
            <li>
              Hobbies: running and biking, sewing, pacific northwest hiking
            </li>
          </ul>
          <br />
        </div>
      </div>
    </div>
  );
};

// function Project({ title, desc }) {
//   return (
//     <div className="project">
//       <img src={`./${title.toLowerCase()}_cover.png`} alt={title} />
//       <caption>
//         <div className="project-title"> {title} </div>
//         {desc}
//       </caption>
//     </div>
//   );
// }

// function showskills({ skills }) {}

export default Home;
